import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4122eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Events footer-white-after grid padded" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "debug",
  "data-scroll-section": ""
}, null, -1))
const _hoisted_3 = {
  class: "Events__Right",
  "data-sticky-container": "",
  "data-scroll-section": ""
}
const _hoisted_4 = {
  key: 1,
  class: "Events__Empty",
  "data-scroll-section": ""
}
const _hoisted_5 = { class: "picture" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", { srcset: "/images/events/empty.png 1x, /images/events/empty@2x.png 2x" }, null, -1))
const _hoisted_7 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsList = _resolveComponent("EventsList")!
  const _component_EventsItem = _resolveComponent("EventsItem")!
  const _component_StickyElement = _resolveComponent("StickyElement")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    (_ctx.eventPage?.events.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_EventsList, {
            "data-scroll-section": "",
            id: "jobBoardList"
          }),
          _createElementVNode("article", _hoisted_3, [
            _createVNode(_component_StickyElement, { class: "Events__Right__Sticky" }, {
              default: _withCtx(() => [
                _createVNode(_component_EventsItem)
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("picture", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("img", {
              src: "/images/events/empty.png",
              alt: _ctx.$t('events.empty')
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('events.empty')), 1)
        ]))
  ]))
}